import React from 'react'
import './issueLoader.css'

export const IssueLoader = ({ label = 'Загрузка заказа', message, className = '' }) => {
	return (
		<div className={`loaderWrapper ${className}`.trim()} role="status" aria-label={label}>
			<div className="circ z">
				<div className="head">
					<div className="eye"></div>
				</div>
				<div className="body"></div>
				<div className="hands"></div>
				<div className="load">Терпим . . .</div>
			</div>

			<div className="subText">
				{message || 'Ожидание не должно превышать 10 секунд. Если заказ не отображается — обновите страницу. При отсутствии результата напишите в чат по заказу.'}
			</div>
		</div>
	)
}
